import { util, shapes } from '@clientio/rappid';
import { StartAttributes } from './start.attributes';

export class StartShape extends shapes.standard.Rectangle {
  defaults(): object {
    return util.defaultsDeep(StartAttributes, shapes.standard.Rectangle.prototype.defaults);
  }
}
